import { useMemo } from 'react'
import { Button } from 'react-bootstrap'

import deleteIcon from '../../../imgs/bin.png'
export const usePackageReqColDefs = ({ canRemove, onRemoveClick, onSetPackageReqChosen, reqType }) =>
  useMemo(
    () => [
      ...(reqType === 'all'
        ? [
            {
              field: 'reqType',
              headerName: 'Request Type',
              valueGetter: params => params.data.reqType?.replace('Request', ''),
              flex: 1,
            },
          ]
        : []),
      {
        field: 'xlt',
        headerName: 'XLT',
        flex: 1.2,
      },
      {
        field: 'warehouseLocation',
        headerName: 'Location',
        flex: 1.5,
      },
      {
        field: 'unit',
        headerName: 'Unit',
        flex: 1.2,
      },
      {
        field: 'costumerFullName',
        headerName: 'Customer Name',
        valueGetter: params => params.data.costumerFullName,
        flex: 1.5,
      },
      {
        field: 'costumerEmail',
        headerName: 'Customer Email',
        flex: 1.5,
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        initialSort: 'asc',
        valueGetter: params => (params.data.createdAt ? new Date(params.data.createdAt).toISOString().split('T')[0] : null),
        flex: 1.2,
      },
      {
        field: 'warehouse',
        headerName: 'Warehouse',
        flex: 1,
      },
      ...(reqType === 'uniteRequest'
        ? [
            {
              field: 'unitePackageIds',
              headerName: 'Package Count',
              valueGetter: params => params.data.unitePackageIds?.length || 0,
              flex: 1,
            },
          ]
        : []),
      {
        field: 'id',
        headerName: 'Request ID',
        flex: 1,
      },
      {
        colId: 'actions',
        headerName: 'Actions',
        cellRenderer: params => (
          <div>
            {reqType === 'uniteRequest' && canRemove && (
              <Button
                onClick={() => onRemoveClick(params.data)}
                variant='link'
                style={{ width: 'fit-content', height: 'fit-content', padding: '0px' }}
              >
                <img src={deleteIcon} height='30px' alt='delete' />
              </Button>
            )}
            <Button className='btn-icon' size='sm' onClick={() => onSetPackageReqChosen(params.data)}>
              ⮕
            </Button>
          </div>
        ),
        sortable: false,
        filter: false,
        width: 120,
      },
    ],
    [canRemove, onRemoveClick, onSetPackageReqChosen, reqType]
  )
